import type { GroupDailyStatsDTO } from "../types/stat.d";
import type { WeekData } from "../components/common/weekTableReal";

const frWeekdays = [
  "Dimanche",
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
];

const frMonths = [
  "janvier",
  "février",
  "mars",
  "avril",
  "mai",
  "juin",
  "juillet",
  "août",
  "septembre",
  "octobre",
  "novembre",
  "décembre",
];

const formatCsvDate = (d: Date) => `${d.getDate()}-${frMonths[d.getMonth()]}`;

const addDays = (date: Date, days: number) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

function buildHeaders() {
  const header1 = [
    "",
    "",
    "IT + G&C + T&T",
    "",
    "",
    "IT + G&C",
    "Individual Travelers  (IT)",
    "",
    "",
    "Tour and Travel (T&T)",
    "",
    "",
    "Groupes (G&C + T&T)",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ].join(";");
  const header2 = [
    "",
    "Date",
    "Nuitées disponibles",
    "taux d'occupation total",
    "nuitées occupées totales",
    "nombre de visiteurs totaux",
    "Nuitées occupées",
    "Taux d'occupation",
    "Nombre de visiteurs",
    "Nuitées occupées",
    "Taux d'occupation",
    "Nombre de visiteurs",
    "Nuitées Groupes occupées",
    "Taux d'occupation",
    "Nombre de visiteurs",
    "Nbre de groupes < 50 personnes",
    "Nbre de groupes > 50 personnes",
    "Nbre de groupes 0 - 99 nuitées",
    "Nbre de groupes 100 - 199 nuitées",
    "Nbre de groupes 200 nuitées +",
    'Nbre de groupes "CORPORATIF"',
    'Nbre de groupes "ASSOCIATIF"',
    'Nbre de groupes "SPORT"',
    'Nbre de groupes "LOISIR"',
  ].join(";");
  return { header1, header2 };
}

export function buildOccupationCsvTemplate(startDate: Date): string {
  const { header1, header2 } = buildHeaders();
  const lines: string[] = [header1, header2];
  for (let i = 0; i < 7; i++) {
    const d = addDays(startDate, i);
    const weekday = frWeekdays[d.getDay()];
    const dateLabel = formatCsvDate(d);
    // Keep same number of columns as existing implementation
    const row = [weekday, dateLabel, ...Array(22 - 1).fill("")].join(";");
    lines.push(row);
  }
  lines.push(["Total semaine", ...Array(22).fill("")].join(";"));
  return lines.join("\n");
}

export function buildOccupationCsvExport(
  startDate: Date,
  weekData: WeekData,
  weekIT: WeekData,
  weekTT: WeekData,
  weekGroup: WeekData,
  groupStatsByDay: Record<number, GroupDailyStatsDTO>,
  defaultAvail: number = 0
): string {
  const { header1, header2 } = buildHeaders();
  const lines: string[] = [header1, header2];
  for (let i = 0; i < 7; i++) {
    const d = addDays(startDate, i);
    const weekday = frWeekdays[d.getDay()];
    const dateLabel = formatCsvDate(d);
    const avail =
      weekGroup[i]?.nuiteesDisponibles ??
      weekData[i]?.nuiteesDisponibles ??
      defaultAvail;
    const itN = weekIT[i]?.nuiteesOccupees ?? 0;
    const ttN = weekTT[i]?.nuiteesOccupees ?? 0;
    const gN = weekGroup[i]?.nuiteesOccupees ?? 0;
    const totalN = itN + ttN + gN;
    const itV = weekIT[i]?.nombreDeVisiteurs ?? 0;
    const ttV = weekTT[i]?.nombreDeVisiteurs ?? 0;
    const gV = weekGroup[i]?.nombreDeVisiteurs ?? 0;
    const totalV = itV + ttV + gV;
    const pctTotal = avail > 0 ? Math.round((totalN / avail) * 100) : "";
    const pctIT = avail > 0 ? Math.round((itN / avail) * 100) : "";
    const pctTT = avail > 0 ? Math.round((ttN / avail) * 100) : "";
    const pctG = avail > 0 ? Math.round((gN / avail) * 100) : "";
    const gs = groupStatsByDay[i] || ({} as GroupDailyStatsDTO);
    const row = [
      weekday,
      dateLabel,
      avail,
      pctTotal,
      totalN,
      totalV,
      itN,
      pctIT,
      itV,
      ttN,
      pctTT,
      ttV,
      gN,
      pctG,
      gV,
      gs.groupCountUnder50 ?? 0,
      gs.groupCountOver50 ?? 0,
      gs.groupCountNights0_99 ?? 0,
      gs.groupCountNights100_199 ?? 0,
      gs.groupCountNights200Plus ?? 0,
      gs.groupCountCorporatif ?? 0,
      gs.groupCountAssociatif ?? 0,
      gs.groupCountSport ?? 0,
      gs.groupCountLoisir ?? 0,
    ].join(";");
    lines.push(row);
  }
  lines.push(["Total semaine", ...Array(22).fill("")].join(";"));
  return lines.join("\n");
}
